import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import { GeoAccessContext } from '../context/geo-access-context';
import { animation, GlobalStyle } from '../ui-components';
import AppFooter from './footer';
import AppHeader from './header';

import './layout.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Redirect } from './redirect';

const propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  globalPage: PropTypes.bool
};

/**
 * @component Root
 * 
 * @param {object} props
 * 
 * @prop {object} children
 * @prop {string} className
 * @prop {boolean} globalPage
 * 
 * @return {object}
 */
const Root = props => {
  const { children, className, globalPage = false } = props;
  const { allowAccess } = useContext(GeoAccessContext);
  const [show, setShow] = useState(false);
  const [displayRedirect, setDisplayRedirect] = useState(false);
  const [redirectOrgin, setRedirectOrigin] = useState('');

  useEffect(() => {
    setShow(allowAccess);

    if (typeof window !== 'undefined') {
      const searchParam = window?.location?.search;

      // Check if the search param contains redirect flag
      if(searchParam && searchParam.includes("redirect=true")) {
        if(searchParam.includes("tadigital")) {
          setRedirectOrigin("tadigital.com");
          setDisplayRedirect(true);
        } else if(searchParam.includes("brightgen")) {
          setRedirectOrigin("brightgen.com");
          setDisplayRedirect(true);
        } else if(searchParam.includes("areteans")) {
          setRedirectOrigin("areteanstech.com");
          setDisplayRedirect(true);
        }     
      }
    }
  }, [allowAccess]);

  const handleRedirectDismiss = () => {
    setDisplayRedirect(false);
  };

  return (
    <AppWrapper fade={show}>
      {displayRedirect && <Redirect onDismiss={handleRedirectDismiss} origin={redirectOrgin} />}
      <GlobalStyle headerFont="Tiempos Headline, serif" bodyFont="Lato, sans-serif" />
      {!globalPage && <AppHeader />}
      <main className={className}>{children}</main>
      {!globalPage && <AppFooter />}
    </AppWrapper>
  );
};

const AppWrapper = styled.div`
  opacity: ${props => (props.fade ? 1 : 0)};
  transition-delay: 0.3s;
  transition: ${animation.general.transition};
`;

Root.propTypes = propTypes;

export default Root;
